import {
  defaultInvoiceContentSectionOne,
  defaultInvoiceContentSectionTwo,
  defaultInvoiceFooterContentSectionFour,
  defaultInvoiceFooterContentSectionOne,
  defaultInvoiceFooterContentSectionThree,
  defaultInvoiceFooterContentSectionTwo,
  defaultInvoiceHeaderLogo,
  defaultInvoiceHeaderText,
} from '../../../../core/constants-repository/invoice-template-content-areas.constants';
import { SectionDefinition, SectionId } from '../../theme.types';

export const StandardSectionIds = {
  HeaderImage: 'header-image-section' as SectionId<'header-image-section'>,
  HeaderText: 'header-text-section' as SectionId<'header-text-section'>,
  ContentOne: 'content-section-one' as SectionId<'content-section-one'>,
  ContentTwo: 'content-section-two' as SectionId<'content-section-two'>,
  FooterOne: 'footer-section-one' as SectionId<'footer-section-one'>,
  FooterTwo: 'footer-section-two' as SectionId<'footer-section-two'>,
  FooterThree: 'footer-section-three' as SectionId<'footer-section-three'>,
  FooterFour: 'footer-section-four' as SectionId<'footer-section-four'>,
} as const;

export type StandardSectionId = (typeof StandardSectionIds)[keyof typeof StandardSectionIds];

export const StandardSections: readonly SectionDefinition<StandardSectionId>[] = [
  {
    id: StandardSectionIds.HeaderImage,
    label: 'Header Image Left',
    group: 'Header',
    defaultContent: defaultInvoiceHeaderLogo,
  },
  {
    id: StandardSectionIds.HeaderText,
    label: 'Header Text Right',
    group: 'Header',
    defaultContent: defaultInvoiceHeaderText,
  },
  {
    id: StandardSectionIds.ContentOne,
    label: 'Content Text First Row',
    group: 'Content',
    defaultContent: defaultInvoiceContentSectionOne,
  },
  {
    id: StandardSectionIds.ContentTwo,
    label: 'Content Text Second Row',
    group: 'Content',
    defaultContent: defaultInvoiceContentSectionTwo,
  },
  {
    id: StandardSectionIds.FooterOne,
    label: 'Footer Text First Column',
    group: 'Footer',
    defaultContent: defaultInvoiceFooterContentSectionOne,
  },
  {
    id: StandardSectionIds.FooterTwo,
    label: 'Footer Text Second Column',
    group: 'Footer',
    defaultContent: defaultInvoiceFooterContentSectionTwo,
  },
  {
    id: StandardSectionIds.FooterThree,
    label: 'Footer Text Third Column',
    group: 'Footer',
    defaultContent: defaultInvoiceFooterContentSectionThree,
  },
  {
    id: StandardSectionIds.FooterFour,
    label: 'Footer Text Fourth Column',
    group: 'Footer',
    defaultContent: defaultInvoiceFooterContentSectionFour,
  },
];
